import { MainNavigationClicked, SubNavigationClicked } from '../../../components/HeaderNew/actionTypes.js';
const trackMainNavigationClick = event => {
  return {
    event: 'search',
    event_action: 'click_search_main_navigation',
    click_text: event.payload.text,
    non_interaction: false
  };
};
const trackSubNavigationClick = event => {
  return {
    event: 'search',
    event_action: 'click_search_sub_navigation',
    click_text: event.payload.text,
    non_interaction: false
  };
};
export const trackingEvents = {
  [MainNavigationClicked]: trackMainNavigationClick,
  [SubNavigationClicked]: trackSubNavigationClick
};